<template>
  <div class="my-scenes-apply-body">
    <div class="my-scenes-apply-page-head">
      <router-link to="/after/myScenes/list" tag="a"
        ><a-icon type="left" />返回上一页</router-link
      >
      <span>/</span>
      <p>场景申报</p>
    </div>
    <div class="my-scenes-apply-content-body">
      <div class="my-scenes-apply-info-body">
        <div class="my-scenes-apply-info">
          <a-form-model
            v-if="!verify"
            ref="ruleForm"
            :model="form"
            :rules="rules"
          >
            <a-form-model-item ref="name" label="场景名称" prop="name">
              <a-input
                v-model="form.name"
                placeholder="请填写场景名称"
                @blur="
                  () => {
                    $refs.name.onFieldBlur();
                  }
                "
              />
            </a-form-model-item>
            <a-form-model-item label="场景领域" prop="field">
              <a-select
                style="width: 600px"
                v-model="form.field"
                placeholder="请选择场景领域"
              >
                <a-select-option
                  v-for="item in fieldData"
                  :key="item.code"
                  :value="item.code"
                  >{{ item.text }}</a-select-option
                >
              </a-select>
            </a-form-model-item>
            <a-form-model-item label="场景应用行业" prop="industry">
              <a-select
                style="width: 600px"
                v-model="form.industry"
                placeholder="请选择场景应用行业"
              >
                <a-select-option
                  v-for="item in industryData"
                  :key="item.code"
                  :value="item.code"
                  >{{ item.text }}</a-select-option
                >
              </a-select>
            </a-form-model-item>
            <a-form-model-item label="场景类别" prop="skill">
              <a-select
                style="width: 600px"
                v-model="form.skill"
                placeholder="请选择场景类别"
              >
                <a-select-option
                  v-for="item in skillData"
                  :key="item.code"
                  :value="item.code"
                  >{{ item.text }}</a-select-option
                >
              </a-select>
            </a-form-model-item>
            <a-form-model-item label="联合申报单位" prop="unit">
              <a-input v-model="form.unit" placeholder="请填写联合申报单位" />
            </a-form-model-item>
            <a-form-model-item ref="contact" label="联系人" prop="contact">
              <a-input
                v-model="form.contact"
                placeholder="请填写联系人姓名"
                @blur="
                  () => {
                    $refs.contact.onFieldBlur();
                  }
                "
              />
            </a-form-model-item>
            <a-form-model-item
              ref="contactDetails"
              label="联系方式"
              prop="contactDetails"
            >
              <a-input
                v-model="form.contactDetails"
                placeholder="请填写联系方式"
                @blur="
                  () => {
                    $refs.contactDetails.onFieldBlur();
                  }
                "
              />
            </a-form-model-item>
            <a-form-model-item ref="address" label="场景地址" prop="address">
              <a-input
                v-model="form.address"
                placeholder="请填写场景地址"
                @blur="
                  () => {
                    $refs.address.onFieldBlur();
                  }
                "
              />
            </a-form-model-item>
            <a-form-model-item ref="keyword" label="场景关键词" prop="keyword">
              <!-- <a-input
                v-model="form.keyword"
                placeholder="请填写场景关键词   "
                @blur="
                  () => {
                    $refs.keyword.onFieldBlur();
                  }
                "
              /> -->
              <a-select
                mode="tags"
                v-model="form.keyword"
                :token-separators="['.']"
                @change="handleChange"
                style="width: 600px"
                dropdown-class-name="select-keyword"
              >
                <a-select-option value="keyword"> keyword </a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item label="场景简介" prop="desc">
              <a-input
                v-model="form.desc"
                type="textarea"
                placeholder="可根据以下几点填写：
1.背景情况介绍；
2.场景具体描述（包括但不限于建设总体目标、建设内容、预期成效）等"
              />
            </a-form-model-item>
            <a-form-model-item label="场景建设需求" prop="demand">
              <a-input
                v-model="form.demand"
                type="textarea"
                placeholder="可根据以下几点填写，如：
场景建设过程中产生的需求，如技术需求（技术和网络、芯片模组、行业终端、应用标准
等）、合作生态、资金需求、复制推广需求等"
              />
            </a-form-model-item>
            <a-form-model-item label="场景配套资源" prop="resources">
              <a-input
                v-model="form.resources"
                type="textarea"
                placeholder="请填写场景配套资源"
              />
            </a-form-model-item>
            <a-form-model-item label="预估启动建设年月" prop="date1">
              <a-date-picker
                v-model="form.date1"
                type="date"
                format="YYYY-MM-DD"
                placeholder="请选择预估启动建设年月"
                style="width: 600px"
                @change="formDate"
              />
            </a-form-model-item>
            <a-form-model-item ref="amount" label="预估成本" prop="amount">
              <a-input
                type="number"
                v-model="form.amount"
                placeholder="请填写预估成本"
                suffix="万"
                style="width: 600px"
                @change="amount"
                @blur="
                  () => {
                    $refs.amount.onFieldBlur();
                  }
                "
              />
            </a-form-model-item>
            <a-form-model-item label="预估资金来源" prop="source">
              <a-input
                v-model="form.source"
                type="textarea"
                placeholder="请填写预估资金来源"
              />
            </a-form-model-item>
            <a-form-model-item style="padding-left: 140px">
              <a-button class="btn-green" @click="onSubmit">
                提交审核
              </a-button>
              <a-button
                class="btn-white"
                style="margin-left: 10px"
                @click="resetForm"
                >保存</a-button
              >
            </a-form-model-item>
          </a-form-model>
          <!-- 审核中样式 -->
          <div v-else class="verify-box">
            <img src="@/assets/img/cjsh.png" />
            <p>您申报的场景已提交至平台审核，请耐心等待...</p>
            <div>
              <a-button class="btn-green">查看详情</a-button>
              <a-button class="btn-gray" style="margin-left: 20px"
                >返回列表</a-button
              >
            </div>
          </div>
        </div>
      </div>
      <div class="my-scenes-apply-faq">
        <div class="my-scenes-apply-cx">
          <img src="@/assets/img/cj1.png" />
          <div>
            <div>
              <p>场景要素知识云</p>
              <span>场景要素寻源搜索引擎服务</span>
            </div>
            <span @click="noUrl">立即咨询 ></span>
          </div>
        </div>
        <div class="my-scenes-apply-faq-desc">
          <p><img src="@/assets/img/bangzhu.png" /> 如何填写场景资料？</p>
          <div>
            尽量简明扼要，内容上尽量做到：<br />
            1.内容描述要清晰明了，可根据提示文字简述；<br />
            2.把建设需求说清楚，包括需要的技术、资金等等；<br />
            3.内容可能会被很多人看到，尽量别包含隐私信息。
            <p>如果填写场景资料有困难，请联系<span>场景辅导专员</span></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  submitScene,
  commonCode,
  sceneCreateDraft,
  submitSceneDraft,
  sceneUpdateDraft,
} from "@/api/scene";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      other: "",
      form: {
        name: "",
        field: undefined,
        industry: undefined,
        skill: undefined,
        unit: "",
        contact: "",
        contactDetails: "",
        address: "",
        keyword: undefined,
        desc: "",
        demand: "",
        resources: "",
        date1: undefined,
        amount: "",
        source: "",
      },
      verify: false,
      rules: {
        name: [
          {
            required: true,
            message: "请填写场景名称",
            trigger: "blur",
          },
        ],
        field: [
          {
            required: true,
            message: "请选择场景领域",
            trigger: "change",
          },
        ],
        industry: [
          {
            required: true,
            message: "请选择场景应用行业",
            trigger: "change",
          },
        ],
        // skill: [
        //   {
        //     required: true,
        //     message: "请选择场景类别",
        //     trigger: "change",
        //   },
        // ],
        contact: [
          {
            required: true,
            message: "请填写联系人姓名",
            trigger: "blur",
          },
        ],
        contactDetails: [
          {
            required: true,
            message: "请填写联系方式",
            trigger: "blur",
          },
        ],
        address: [
          {
            required: true,
            message: "请填写场景地址",
            trigger: "blur",
          },
        ],
        // keyword: [
        //   {
        //     required: true,
        //     message: "请填写场景关键词",
        //     trigger: "blur",
        //   },
        // ],
        desc: [
          {
            required: true,
            message: "请填写场景简介",
            trigger: "blur",
          },
        ],
        // demand: [
        //   {
        //     required: true,
        //     message: "请填写场景建设需求",
        //     trigger: "blur",
        //   },
        // ],
        // resources: [
        //   {
        //     required: true,
        //     message: "请填写场景配套资源",
        //     trigger: "blur",
        //   },
        // ],
        // date1: [
        //   {
        //     required: true,
        //     message: "请选择预估启动建设年月",
        //     trigger: "change",
        //   },
        // ],
        // amount: [
        //   {
        //     required: true,
        //     message: "请填写预估成本",
        //     trigger: "blur",
        //   },
        // ],
      },
      fieldData: [],
      industryData: [],
      skillData: [],
      scenesInfo: "",
      scenesType: "",
    };
  },
  mounted() {
    this.scenesInfo = this.$route.params.info;
    this.scenesType = this.$route.params.type;
    this.loadfield();
    this.loadindustry();
    this.loadSkill();
    this.loadFormInfo();
  },
  methods: {
    noUrl(){
      this.$message.warning("暂无跳转链接！")
    },
    amount(e) {
      if (this.form.amount != "" && this.form.amount < 0) {
        this.form.amount = 1;
      }
    },
    handleChange(value) {},
    loadFormInfo() {
      let scenesInfo = this.scenesInfo;
      if (this.scenesType == "edit") {
        this.form.name = scenesInfo.sceneName;
        this.form.field = scenesInfo.fieldLevelOne;
        this.form.industry = scenesInfo.industryLevelOne;
        this.form.skill = scenesInfo.skillLevelOne;
        this.form.unit = scenesInfo.associate;
        this.form.contact = scenesInfo.contactPerson;
        this.form.contactDetails = scenesInfo.contactDetail;
        this.form.address = scenesInfo.contactAddress;
        this.form.keyword = scenesInfo.sceneKeywords
          ? scenesInfo.sceneKeywords.split(";")
          : undefined;
        this.form.desc = scenesInfo.description;
        this.form.demand = scenesInfo.requirement;
        this.form.resources = scenesInfo.resource;
        this.form.date1 = scenesInfo.expectedStartDate;
        this.form.amount = scenesInfo.fundAmount;
        this.form.source = scenesInfo.fundSource;
      }
    },
    loadfield() {
      let obj = {
        type: "FIELD",
        precode: "000",
      };
      commonCode(obj).then((res) => {
        this.fieldData = res.data;
      });
    },
    loadindustry() {
      let obj = {
        type: "INDUSTRY",
        precode: "000",
      };
      commonCode(obj).then((res) => {
        this.industryData = res.data;
      });
    },
    loadSkill() {
      let obj = {
        type: "SKILL",
        precode: "000",
      };
      commonCode(obj).then((res) => {
        this.skillData = res.data;
      });
    },
    formDate(e, date) {
      this.form.date1 = date;
    },
    onSubmit() {
      let _this = this;
      let form = this.form;
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let data = {
            sceneName: form.name,
            fieldLevelOne: form.field,
            industryLevelOne: form.industry,
            skillLevelOne: form.skill,
            associate: form.unit,
            contactPerson: form.contact,
            contactDetail: form.contactDetails,
            contactAddress: form.address,
            sceneKeywords: form.keyword ? form.keyword.join(";") : form.keyword,
            description: form.desc,
            requirement: form.demand,
            resource: form.resources,
            expectedStartDate: form.date1,
            fundAmount: form.amount,
            fundSource: form.source,
          };
          if (_this.scenesType == "add") {
            submitScene(data).then((res) => {
              _this.$message.success("提交成功！");
              _this.$refs.ruleForm.resetFields();
              setTimeout(function () {
                _this.$router.push("/after/myScenes/list");
              }, 1000);
            });
          } else {
            data.sceneId = this.scenesInfo.id;
            submitSceneDraft(data).then((res) => {
              _this.$message.success("提交成功！");
              _this.$refs.ruleForm.resetFields();
              setTimeout(function () {
                _this.$router.push("/after/myScenes/list");
              }, 1000);
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm() {
      let _this = this;
      let form = this.form;
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let data = {
            sceneName: form.name,
            fieldLevelOne: form.field,
            industryLevelOne: form.industry,
            skillLevelOne: form.skill,
            associate: form.unit,
            contactPerson: form.contact,
            contactDetail: form.contactDetails,
            contactAddress: form.address,
            sceneKeywords: form.keyword ? form.keyword.join(";") : form.keyword,
            description: form.desc,
            requirement: form.demand,
            resource: form.resources,
            expectedStartDate: form.date1,
            fundAmount: form.amount,
            fundSource: form.source,
          };
          if (_this.scenesType == "add") {
            sceneCreateDraft(data).then((res) => {
              _this.$success({
                title: "保存草稿成功",
                okText: "确定",
                class: "submit-draft-box",
                content: (
                  <div>
                    <p>草稿可在“我的场景-待提交”列表查看</p>
                  </div>
                ),
              });
              setTimeout(function () {
                _this.$router.push("/after/myScenes/list");
              }, 1000);
              _this.$refs.ruleForm.resetFields();
            });
          } else {
            data.sceneId = this.scenesInfo.id;
            sceneUpdateDraft(data).then((res) => {
              _this.$success({
                title: "保存草稿成功",
                okText: "确定",
                class: "submit-draft-box",
                content: (
                  <div>
                    <p>草稿可在“我的场景-待提交”列表查看</p>
                  </div>
                ),
              });
              setTimeout(function () {
                _this.$router.push("/after/myScenes/list");
              }, 1000);
              _this.$refs.ruleForm.resetFields();
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.my-scenes-apply-body {
  padding: 24px;
  background: #f5f5f5;
  height: 100%;
  .my-scenes-apply-page-head {
    display: flex;
    align-items: center;
    color: #8c8c8c;
    line-height: 14px;
    height: 14px;
    margin-bottom: 24px;
    > a {
      color: #8c8c8c;
    }
    > span {
      margin: 0 6px;
    }
  }
  .my-scenes-apply-content-body {
    display: flex;
    height: calc(100% - 38px);
    .my-scenes-apply-info-body {
      flex: 1;
      height: 100%;
      overflow-y: auto;
      background: #fff;
      padding: 40px 0;
      .my-scenes-apply-info {
        display: flex;
        justify-content: center;
        .ant-form-item {
          display: flex;
        }
        .verify-box {
          text-align: center;
          padding-top: 100px;
          > img {
            display: block;
            margin: 0 auto;
          }
          > p {
            line-height: 14px;
            margin-top: 40px;
          }
          > div {
            display: flex;
            justify-content: center;
            margin-top: 80px;
          }
        }
      }
    }
    .my-scenes-apply-faq {
      width: 280px;
      margin-left: 24px;
      .my-scenes-apply-cx {
        position: relative;
        width: 280px;
        height: 80px;
        > img {
          width: 100%;
          height: 100%;
        }
        > div {
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          z-index: 2;
          padding: 20px 15px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          > div {
            > p {
              text-shadow: 2px 2px 2px rgba(000, 000, 000, 0.25);
              font-size: 18px;
              line-height: 20px;
              margin-bottom: 8px;
              color: #fff;
            }
            > span {
              font-size: 12px;
              display: block;
              line-height: 12px;
              color: #fff;
            }
          }
          > span {
            height: 24px;
            border: 1px solid #ffffff;
            line-height: 22px;
            padding: 0 10px;
            color: #fff;
            font-size: 12px;
            cursor: pointer;
          }
        }
      }
      .my-scenes-apply-faq-desc {
        margin-top: 24px;
        background: #fff;
        > p {
          display: flex;
          align-items: center;
          padding: 0 16px;
          height: 48px;
          border-bottom: 1px solid #f0f0f0;
        }
        > div {
          padding: 24px;
          line-height: 20px;
          text-align: justify;
          > p {
            margin-top: 20px;
            > span {
              color: #1abc9c;
            }
          }
        }
      }
    }
  }
}
</style>
<style>
.select-keyword {
  display: none !important;
}
.my-scenes-apply-info .ant-form-item-label {
  line-height: 32px !important;
  min-width: 140px !important;
  text-align: right;
}
.my-scenes-apply-info input {
  width: 600px;
  height: 32px;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
}
.my-scenes-apply-info select {
  height: 32px;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
}
.my-scenes-apply-info textarea {
  width: 600px;
  height: 88px !important;
}
.my-scenes-apply-info .ant-form-item-control {
  line-height: 32px;
}
.submit-draft-box .ant-modal-confirm-btns > button {
  height: 32px;
  line-height: 32px;
  background: #1abc9c !important;
  border-radius: 2px;
  color: #fff !important;
  border-color: #1abc9c !important;
}
</style>
